define('TescoMobile_Checkout/js/view/choices-modal-spend-cap',['uiComponent', 'jquery', 'ko', 'Magento_Ui/js/modal/modal', '../action/get-spend-caps', '../action/save-spend-cap', 'Magento_Catalog/js/price-utils', 'mage/translate'], function (Component, $, ko, modal, getSpendCapsAction, saveSpendCapAction, priceUtils) {
  'use strict';

  return Component.extend({
    defaults: {
      highSpendCapThreshold: 40
    },
    modalWindow: null,
    isLoading: ko.observable(true),
    spendCaps: ko.observableArray(),
    messages: ko.observableArray(),
    quoteItemId: null,
    currentSpendCap: ko.observable(),
    currentSpendCapSku: ko.observable(),
    currentSpendCapAllowanceValue: ko.observable(),
    setModalElement: function (element) {
      var self = this;
      var options = {
        modalClass: 'spend-cap-modal show-close',
        responsive: true,
        innerScroll: true,
        type: 'popup',
        clickableOverlay: false,
        opened: function (a, b) {
          this._updateContent(element);
        }.bind(this)
      };
      this.modalWindow = element;
      modal(options, $(this.modalWindow));
      $(this.modalTrigger).on('click', function (event) {
        this.spendCaps([]);
        var item = $(event.target).parent('div.sub-item');
        this.quoteItemId = item.data('quoteItemId');
        this.currentSpendCap(this.getSpendCapValue(item.data('currentCap')));
        this.currentSpendCapSku(this.getSpendCapValue(item.data('currentCapSku')));
        $(this.modalWindow).modal('openModal');
      }.bind(this));
    },
    initialize: function () {
      this._super();
      this.isHighSpendCap = ko.computed(function () {
        return this.currentSpendCap() === 'high_usage_limit' || this.currentSpendCapAllowanceValue() > this.highSpendCapThreshold;
      }, this);
    },
    selectCap: function (spendCap) {
      if (!spendCap) {
        return false;
      }
      if (spendCap.allowances[0].allowance_type === 'high_usage_limit') {
        this.currentSpendCap('high_usage_limit');
      } else {
        this.currentSpendCap(this.getSpendCapValue(spendCap.allowances[0].allowance_value));
      }
      this.currentSpendCapAllowanceValue(spendCap.allowances[0].allowance_value);
      this.currentSpendCapSku(spendCap.sku);
      return true;
    },
    saveSpendCap: function () {
      this.isLoading(true);
      var deferred = $.Deferred();
      deferred.done(function () {
        this.isLoading(false);
        $('body').loader('show');
        $(this.modalWindow).modal('closeModal');
        location.reload();
      }.bind(this)).fail(function (response) {
        this.isLoading(false);
        if (response.message) {
          this.messages([{
            type: 'error',
            text: $.mage.__(response.message)
          }]);
        }
      }.bind(this));
      saveSpendCapAction(this.quoteItemId, this.currentSpendCapSku(), deferred);
    },
    getSpendCapValue: function (spendCap) {
      if (spendCap == 0) {
        return 'zero';
      }
      return spendCap;
    },
    formatPrice: function (price) {
      return priceUtils.formatPrice(price);
    },
    getHighlightWrapper: function (price) {
      return '<strong>' + price + '</strong>';
    },
    _updateContent: function (element) {
      var deferred = $.Deferred();
      this.isLoading(true);
      getSpendCapsAction(this.quoteItemId, deferred);
      $.when(deferred).done(function (result) {
        for (var i = 0; i < result.length; i++) {
          if (result[i].sku === this.currentSpendCapSku()) {
            this.currentSpendCapAllowanceValue(result[i].allowances[0].allowance_value);
            break;
          }
        }
        this.spendCaps(result);
        this.isLoading(false);
      }.bind(this));
    }
  });
});

